import { GridCellProps, GridColumn as Column } from "@progress/kendo-react-grid";
import * as React from "react";
import { ColumnMenu } from "../../Layout/Grid/Filter/ColumnMenu";
import { TimePickerCell } from "../../Project/EditProject/RightSide/FtlTab/StopData/TimePickerCell";
import { BranchViewModel } from "./BranchViewModel";
import { DropDownCell } from "../../Layout/Grid/Cell/Default/DropDownCell";
import { CarrierBranchColumnMenu } from "./CarrierBranchColumnMenu";
import { bidPackObjectName } from "../BidPacks/BidPack";
import { ReadOnlyProps } from "../../Project/EditProject/ReadOnlyProps";
import { getLocalizedDataForBranches } from "./getLocalizedDataForBranches";

type Props = {
  filteredBranches: Array<BranchViewModel>;
  branches: Array<BranchViewModel>;
};

export function ManageCutOffGridColumns({
  filteredBranches,
  branches,
  isReadOnly,
}: Props & ReadOnlyProps) {
  const carrierBranchCell = (props: GridCellProps) =>
    DropDownCell({
      ...props,
      editable: true,
      localizedData: getLocalizedDataForBranches(branches),
      onRowClick: () => undefined,
      isReadOnly,
    });

  const timePickerCell = (props: GridCellProps) => {
    return TimePickerCell({
      ...props,
      isReadOnly,
    });
  };

  return [
    <Column
      key="BidPackName"
      field="BidPackName"
      title={bidPackObjectName}
      filter="text"
      columnMenu={ColumnMenu}
      editable={false}
      resizable
    />,
    <Column
      key="DestinationName"
      field="DestinationName"
      title="Destination Name"
      filter="text"
      columnMenu={ColumnMenu}
      editable={false}
      resizable
    />,
    <Column
      key="CountryName"
      field="CountryName"
      title="Country"
      filter="text"
      columnMenu={ColumnMenu}
      editable={false}
      resizable
    />,
    <Column
      key="Zipcode"
      field="Zipcode"
      title="Postcode"
      filter="text"
      columnMenu={ColumnMenu}
      editable={false}
      resizable
    />,
    <Column
      key="ZipArea"
      field="ZipArea"
      title="Postcode Area"
      filter="text"
      columnMenu={ColumnMenu}
      editable={false}
      resizable
    />,
    <Column
      key="SupplierGsdb"
      field="SupplierGsdb"
      title="Supplier GSDB"
      filter="text"
      columnMenu={ColumnMenu}
      editable={false}
      resizable
    />,
    <Column
      key="CutOffTime"
      field="CutOffTime"
      title="Inbound Cut-Off Time"
      filter="text"
      columnMenu={ColumnMenu}
      cell={timePickerCell}
      resizable
    />,
    <Column
      key="ReturnCutOffTime"
      field="ReturnCutOffTime"
      title="Return Cut-Off Time"
      filter="text"
      columnMenu={ColumnMenu}
      cell={timePickerCell}
      resizable
    />,
    <Column
      key="TransitTime"
      field="TransitTime"
      title="Inbound Transit Days"
      filter="numeric"
      columnMenu={ColumnMenu}
      editor="numeric"
      resizable
      editable={!isReadOnly}
    />,
    <Column
      key="ReturnTransitTime"
      field="ReturnTransitTime"
      title="Return Transit Days"
      filter="numeric"
      columnMenu={ColumnMenu}
      editor="numeric"
      resizable
      editable={!isReadOnly}
    />,
    <Column
      key="BranchID"
      field="BranchID"
      title="Carrier Branch"
      filter="text"
      columnMenu={(props) => CarrierBranchColumnMenu(props, filteredBranches)}
      cell={carrierBranchCell}
      width={300}
      resizable
    />,
  ];
}
